var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "list-input-wrapper" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.inputValue,
            expression: "inputValue",
          },
        ],
        staticClass: "input-list-dropdown",
        attrs: { readonly: !_vm.typeable, placeholder: _vm.placeholder },
        domProps: { value: _vm.inputValue },
        on: {
          click: function ($event) {
            _vm.isListOpen = !_vm.isListOpen
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.inputValue = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "cursor-wrapper" }, [
        !_vm.isListOpen
          ? _c("i", {
              staticClass: "icon fa fa-chevron-down",
              on: {
                click: function ($event) {
                  _vm.isListOpen = true
                },
              },
            })
          : _c("i", {
              staticClass: "icon fa fa-chevron-up",
              on: {
                click: function ($event) {
                  _vm.isListOpen = false
                },
              },
            }),
      ]),
    ]),
    _vm._v(" "),
    _vm.isListOpen
      ? _c(
          "ul",
          { staticClass: "list-wrapper" },
          _vm._l(_vm.options, function (option, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "list-option",
                style: index !== 0 ? "border-top: 1px solid #ced4da;" : "",
                on: {
                  click: function ($event) {
                    _vm.inputValue = option
                    _vm.isListOpen = false
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(option) + "\n    ")]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }